import React from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface ConfirmModalProps {
  triggerText: string;
  title: string;
  description: string;
  onConfirm: () => void;
  icon: React.ReactNode;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ triggerText, title, description, onConfirm, icon }) => (
  <Dialog>
    <DialogTrigger asChild>
      <div className="flex cursor-pointer items-center">
        {icon}
        <span>{triggerText}</span>
      </div>
    </DialogTrigger>
    <DialogContent className="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
      </DialogHeader>
      <div className="py-4">
        <p>{description}</p>
      </div>
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="outline">Cancel</Button>
        </DialogClose>
        <Button type="submit" onClick={onConfirm}>
          Confirm
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default ConfirmModal;
